

// editor.on('text-change', (delta, oldDelta, source) => {
//   let insertEvents = delta.ops.filter(op => op.hasOwnProperty('insert'));
//   if (insertEvents.length === 0 || editor.getSelection() === null) return;

//   let cursorIndex = editor.getSelection().index;
//   let text = editor.getContents(0, cursorIndex).ops.map(op => op.insert).join("");

//   let matchArr, start, length, curFormat;
//   while ((matchArr = boldRegex.exec(text)) !== null) {
//     start = matchArr.index;
//     length = matchArr[0].length;
//     curFormat = editor.getFormat(start, length);
//     if (curFormat !== null && curFormat.bold) return;
//     editor.formatText(start, length, 'bold', true);

//     // Is there a better way to do this part, so the next key pressed isn't bold too?
//     editor.format('bold', false);
//   }
// });

/* eslint-disable dot-notation */
import Quill from 'quill';
import type { Delta, EmitterSource } from 'quill/core';

const Module = Quill.import('core/module');

const surrounds = [
    { name: 'bold', char: '*', regex: /\*.+?\*/g },
    { name: 'italic', char: '_', regex: /_.+?_/g },
];

const startOfLines = [
    { name: 'header', param: '1', char: ' ', regex: /^#\s+/g },
    { name: 'header', param: '2', char: ' ', regex: /^##\s+/g },
    { name: 'header', param: '3', char: ' ', regex: /^###\s+/g },
    { name: 'header', param: '4', char: ' ', regex: /^####\s+/g },
    { name: 'header', param: '5', char: ' ', regex: /^#####\s+/g },
    { name: 'header', param: '6', char: ' ', regex: /^######\s+/g },
];

export interface AutoFormatOption {
    bold?: boolean;
    italic?: boolean;
    header?: boolean;
}

export class AutoFormat extends Module<AutoFormatOption> {

    constructor(quill: Quill, options?: Partial<AutoFormatOption>) {
        super(quill, options);

        quill.on('text-change', this.onTextChange.bind(this));
    }

    private onTextChange(delta: Delta, _oldDelta: Delta, source: EmitterSource) {
        if (source !== 'user') return;

        this.handleSurroundingFormats();
        this.handleStartOfLineFormats();
    }

    private handleSurroundingFormats() {

        const cursorPos = this.getCursorPosition();
        const lastChar = this.quill.getText(cursorPos, 1);

        const available = surrounds.filter(x => !!this.options[x.name]);
        const type = available.find(t => t.char === lastChar);
        if (!type) return;

        const ltp = this.getLineToPosition(cursorPos + 1);

        if (ltp.text.match(type.regex)) {

            const start = ltp.start + ltp.text.slice(0, -1).lastIndexOf(type.char);
            const end = Math.max(0, cursorPos) + 1;
            const length = end - start;

            this.quill.deleteText(start, 1);
            this.quill.deleteText(end - 2, 1);

            this.quill.formatText(start, length - 2, type.name, true);
            this.quill.format(type.name, false);
        }
    }

    private handleStartOfLineFormats() {

        const cursorPos = this.getCursorPosition();
        const lastChar = this.quill.getText(cursorPos, 1);

        // Check for any potential SOL formats using last char, before we bother to splice the last line
        const available = startOfLines.filter(x => !!this.options[x.name]);
        const candidates = available.filter(t => t.char === lastChar);
        if (candidates.length === 0) return;

        // Some hits, find the first regex match using the current line to cursor
        const ltp = this.getLineToPosition(cursorPos + 1);
        const hit = candidates.find(x => x.regex.exec(ltp.text));
        if (!hit) return;

        this.quill.formatLine(ltp.start, ltp.length, hit.name, hit.param);
        this.quill.deleteText(ltp.start, ltp.length);

        // const start = ltp.start + ltp.text.slice(0, -1).lastIndexOf(type.char);
        // const end = Math.max(0, cursorPos) + 1;
        // const length = end - start;

        // this.quill.deleteText(start, 1);
        // this.quill.deleteText(end - 2, 1);

        // this.quill.formatText(start, length - 2, type.name, true);
        // this.quill.format(type.name, false);
    }

    private getCursorPosition() {
        const range = this.quill.getSelection();
        return Math.max(0, (range?.index ?? 0) - 1);
    }

    private getLineToPosition(pos: number) {

        // Get all text from the start of document up to cursor
        const textUpToCursor = this.quill.getText(0, pos);

        // Split by newlines and get the last line (current line)
        const lineStartPos = textUpToCursor.lastIndexOf('\n') + 1;

        return {
            start: lineStartPos,
            length: pos - lineStartPos,
            text: this.quill.getText(lineStartPos, pos - lineStartPos),
        };
    }
}
